/* eslint-disable import/first */
import type { ReactNode } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LoadingScreen from 'src/components/LoadingScreen';
import Page from 'src/components/Page';
import useAuth from 'src/hooks/useAuth';
import { PATH_DASHBOARD } from '../routes/paths';
import { isOnboardingEnabled } from 'src/utils/featureFlags';

type OnboardingGuardProps = {
  children?: ReactNode;
};

export default function OnboardingGuard({ children }: OnboardingGuardProps) {
  const PageComponent = Page as any;
  const { user, isLoading } = useAuth();
  const { t } = useTranslation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isOnboardingEnabled(user)) {
    return (
      <PageComponent title={t('onboarding.not-enabled.page-title')}>
        <Container maxWidth="sm">
          <Box mt={10} textAlign="center">
            <Typography variant="h4" mb={2}>
              {t('onboarding.not-enabled.title')}
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={3}>
              {t('onboarding.not-enabled.description')}
            </Typography>
            <Button
              component={RouterLink}
              to={PATH_DASHBOARD.root}
              variant="contained"
            >
              {t('onboarding.not-enabled.return-to-dashboard')}
            </Button>
          </Box>
        </Container>
      </PageComponent>
    );
  }

  return <>{children}</>;
}
